import appApi from '../../../../../api/app-api';
import { LecturesSideBarFilterDatamodel } from '../side-bar-filter/lectures-side-bar-filter-datamodel';
import { ReportLecturesType } from '../../../../../api/types/reports/education/report-lectures.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getLecturesReportData = async (
  filters: LecturesSideBarFilterDatamodel,
  setLoading: (loading: boolean) => any,
  setData: (data: ReportLecturesType[]) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getLecturesReport({
      branchesIds: filters.branchesIds,
      abstractProgramIds: filters.programIds,
      programsStartYears: filters.startYears,
      lectureState: filters.statuses,
      dateRangeStart: filters.lectureDateStart,
      dateRangeEnd: filters.lectureDateEnd,
    });
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};
